export default {
  Eo: "allowCrawlerActivity",
  _o: "baseUrl",
  Io: "noCookies",
  So: "devicePropertyAllowlist",
  ka: "disablePushTokenMaintenance",
  Ao: "enableLogging",
  No: "enableSdkAuthentication",
  _a: "manageServiceWorkerExternally",
  Oo: "minimumIntervalBetweenTriggerActionsInSeconds",
  Ro: "sessionTimeoutInSeconds",
  Po: "appVersion",
  Lo: "appVersionNumber",
  wa: "serviceWorkerLocation",
  Ma: "safariWebsitePushId",
  zn: "localization",
  bo: "contentSecurityNonce",
  Do: "allowUserSuppliedJavascript",
  jo: "inAppMessageZIndex",
  ho: "openInAppMessagesInNewTab",
  en: "openNewsFeedCardsInNewTab",
  Lh: "requireExplicitInAppMessageDismissal",
  Mo: "doNotLoadFontAwesome",
  Uo: "deviceId",
  ya: "serviceWorkerScope",
  Wo: "sdkFlavor",
  tn: "openCardsInNewTab",
};
